export default __webpack_public_path__ + "static/media/Astronomy_CelestialCoordinateConversions_2021.47f7df99.pdf";